import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { AUTH } from "@/constants/testIds";
import { toast } from "sonner";
import { GoogleAuthButton } from "@/components/GoogleAuthButton";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Bienvenue !");
      navigate("/dashboard");
    } else {
      setError(res.error);
    }
  };

  return (
    <Layout withFooter={false}>
      <div className="max-w-md mx-auto px-6 py-16">
        <span className="text-xs tracking-[0.2em] uppercase text-[#11783A] font-medium">Connexion</span>
        <h1 className="font-heading text-4xl font-medium tracking-tight mt-2 mb-2">Bon retour parmi nous</h1>
        <p className="text-muted-foreground mb-8">Accédez à votre tableau de bord 3aqarate.</p>

        <form onSubmit={submit} className="bg-white border border-[#E5E5E5] rounded-2xl p-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              data-testid={AUTH.loginEmail}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 rounded-xl h-11"
              placeholder="vous@example.com"
            />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input
              id="password"
              type="password"
              data-testid={AUTH.loginPassword}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 rounded-xl h-11"
            />
          </div>
          {error && <div className="text-sm text-red-600">{error}</div>}
          <Button
            type="submit"
            data-testid={AUTH.loginSubmit}
            disabled={busy}
            className="w-full h-11 rounded-xl bg-[#D6202C] hover:bg-[#B5181F]"
          >
            {busy ? "Connexion..." : "Se connecter"}
          </Button>

          <div className="flex items-center gap-3 py-1">
            <div className="flex-1 h-px bg-[#E5E5E5]" />
            <span className="text-[10px] uppercase tracking-widest text-muted-foreground">ou</span>
            <div className="flex-1 h-px bg-[#E5E5E5]" />
          </div>
          <GoogleAuthButton />

          <div className="text-sm text-muted-foreground text-center pt-2">
            Pas encore de compte ? <Link to="/register" className="text-[#D6202C] font-medium">Créer un compte</Link>
          </div>
        </form>

        <div className="mt-6 text-xs text-muted-foreground bg-[#F5F0EB] border border-[#E5E5E5] rounded-xl p-4">
          <div className="font-medium text-[#1A1A1A] mb-1">Compte démo</div>
          atlas@3aqarate.com · Demo1234! (Agence Pro Maroc)
        </div>
      </div>
    </Layout>
  );
}
